import { faqService } from './service'
import { createFetchHook } from '../../acato-utils'

export const faqServiceHooks = createFetchHook(faqService)
